<template>
    <form-group
        v-bind="form_group_props"
    >
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint><slot name="hint"></slot></template>
        <div id="card-form" class="card_container columns">
            <div id="card-number-field-container" class="column col-sm-12 col-8"></div>
            <div id="card-expiry-field-container" class="column col-sm-6 col-2"></div>
            <div id="card-cvv-field-container" class="column col-sm-6 col-2"></div>
        </div>
        <!--
        <div class="divider text-center" data-content="OR"></div>
        <div id="paypal-button-container" class="paypal-button-container"></div>
        //-->
    </form-group>
</template>

<script type="text/javascript">
import FormGroup from "@/nibnut/components/Inputs/FormGroup"
import is_nibnut_component from "@/nibnut/mixins/IsNibnutComponent"

export default {
    mixins: [is_nibnut_component],
    components: {
        FormGroup
    },
    mounted () {
        if(!window.paypal) setTimeout(this.initialize, 500)
        else this.initialize()
    },
    methods: {
        initialize () {
            /*
            window.paypal.Buttons({
                createOrder: this.createOrder,
                onApprove: this.approveOrder,
                onError: error => {
                    // Do something with the error from the SDK
                    console.log(error)
                },
                style: {
                    shape: "sharp",
                    layout: "horizontal",
                    color: "white",
                    label: "pay",
                    tagline: false,
                    disableMaxWidth: true,
                    height: 25
                }
            }).render("#paypal-button-container")
            */
            const cardField = window.paypal.CardFields({
                createOrder: this.createOrder,
                onApprove: this.approveOrder,
                style: {
                    input: {
                        "font-size": "16px",
                        "font-family": "inherit",
                        color: "#3b4351",
                        padding: "8px 5px",
                        "border-radius": 0
                    }
                }
            })
            if(cardField.isEligible()) {
                cardField.NumberField().render("#card-number-field-container")
                cardField.CVVField().render("#card-cvv-field-container")
                cardField.ExpiryField().render("#card-expiry-field-container")
                this.$emit("initialized", cardField)
            }
        }
    },
    computed: {
        form_group_props () {
            return {
                id: this.id,
                name: this.name,
                value: "-",
                required: this.required,
                editable: this.editable,
                error: this.error,
                waiting: this.saving
            }
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        required: {
            type: Boolean,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        },
        createOrder: {
            type: Function,
            required: true
        },
        approveOrder: {
            type: Function,
            required: true
        }
    }
}
</script>
